import React, { Component } from 'react'
import { Button, Form, Icon, message, Upload } from 'antd'
import Posts from '../../../api/Posts'
import omitEmpty from 'omit-empty'
import moment from 'moment'
import { get, isEmpty } from 'lodash'
import Files from '../../../api/Files'

import InfoText from '../../../elements/InfoText'
import LzEditor from 'react-lz-editor'

const FormItem = Form.Item

class Post extends Component {
  constructor(props) {
    super(props)
    this.api = new Posts()
    this.state = { loading: false, text: '', fileList: [] }
    this.filesApi = new Files()
  }

  handlePost = async (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          const { fileList, text } = this.state
          const formData = new FormData()
          fileList.forEach((file) => {
            formData.append('upload', file)
          })
          values.text = text
          const data = {
            meta: JSON.stringify(
              omitEmpty({
                timestamp: moment().utc().format(),
                description: values.text,
                category: 'post',
              })
            ),
          }
          for (let name in data) {
            formData.append(name, data[name])
          }

          this.setState({ loading: true })
          let results = await this.filesApi.post.upload(formData)
          let post = { post: { post: values.text } }
          if (!isEmpty(results)) {
            post = {
              post: {
                post: values.text,
                fileList: results,
              },
            }
          }
          await this.api.create(post)
          this.props.form.resetFields()
          this.setState({ loading: false, text: '', fileList: [] })
          this.props.refresh()
        } catch (error) {
          message.error(JSON.stringify(error))
        }
      }
    })
  }
  handelChange = (e) => {
    console.error(e)
    this.setState({
      text: e,
    })
  }

  render() {
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 4,
          offset: 20,
        },
      },
    }

    const uploadProps = {
      onRemove: (file) => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file)
          const newFileList = fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList,
          }
        })
      },
      beforeUpload: (file) => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file],
        }))
        return false
      },
      fileList: this.state.fileList,
      multiple: true,
    }
    return (
      <Form onSubmit={this.handlePost}>
        <LzEditor
          importContent={this.state.text}
          cbReceiver={this.handelChange}
          lang="en"
          image={false}
          video={false}
          audio={false}
        />
        <FormItem>
          <Upload {...uploadProps}>
            <Button disabled={this.state.loading}>
              <Icon type="upload" />
              Upload an Image , PDF or Video
            </Button>
          </Upload>
        </FormItem>
        <InfoText text={'You can upload multiple files.'} />
        <FormItem {...tailFormItemLayout}>
          <Button loading={this.state.loading} type={'primary'} htmlType="submit">
            Submit
          </Button>
        </FormItem>
      </Form>
    )
  }
}

const WrappedNormalPostForm = Form.create()(Post)

export default WrappedNormalPostForm
